import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-permissions-create',
  templateUrl: './permissions-create.component.html',
  styleUrls: ['./permissions-create.component.scss']
})
export class PermissionsCreateComponent implements OnInit {

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  role = null;
  permission = [];

  constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder,  private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {}

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      this.http.get<any>(`${environment.apiUrl}/permissionsById/${id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if(data.data != null){
            this.action = 'Update';
            this.role = data.data.role.toUpperCase();
            this.permission = data.data.permission;
            this.Form.patchValue({
              _id: data.data._id,
              permission: data.data.permission,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

  this.Form = this.formBuilder.group({
      permission: ['', Validators.required],
      _id: ['', ],
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
      let data = ({
        "permission" : this.Form.value.permission,
      })
    this.http.post<any>(`${environment.apiUrl}/permission/`, data, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.Error){
          this.message = res.message;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
          this.router.navigateByUrl('/permissions/list');
        } 
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
      let data = ({
        "permission" : this.Form.value.permission,
        "_id" : this.Form.value._id,
      })
      this.http.put<any>(`${environment.apiUrl}/permission/`, data, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.status == '500'){
          this.message = res.message;
          this.class = 'btn-primary rounded px-1 py-1';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return 0;
        }else{
          this.message = 'Successfully Updated';
          this.class = 'btn-success rounded px-1 py-1';
          this.router.navigateByUrl('/permissions/list');
        } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
